window.qvCarousel= null;
var QuickViewSummary = Class({

    initialize: function(product) {
    	Handlebars.partials 	= Rayban.templates;
	    this.product 			= product;
	    this.containerId 		= "";
	    if(window.isROX == "true" || ($("#isRoxEnabled").length>0 && $("#isRoxEnabled").val() === "true")) this.containerId = "D_QuickView_Prod";
	    else this.containerId 		= "D_QuickView";
        this.container 			= $("#"+this.containerId);
		this.sliderContainer 	= this.container.find(".slider-container");
		this.headerContainer 	= this.container.find(".header-container");
		this.layoutContainer 	= this.container.find(".layout-container");
		this.quickViewTemplate 	= Rayban.templates['quickview-template'];
		this.eventType = ((document.ontouchstart!==null) ? "click" : "touchstart");
		this.isiPad = navigator.userAgent.match(/iPad/i) !== null;
		this.sizeDropdownContainer 	= $("#wcs-size-display");
		this.productSku 			= "";
		this.selectedProductData = [];
    },


	bindEvent: function(self){
		self.container.find(".slider-container .wcs-carousel li a").off(self.eventType).on(self.eventType, {"self": self}, self.productListHandler);
		self.container.find(".wcs-close-btn, .wcs-fadeout-full, .wcs-fadeout").off(self.eventType).on(self.eventType, {"self": self}, self.close);
		$(".wcs-addtobag").off(self.eventType).on(self.eventType, {"self": self}, self.addToBagHandler);
		$(".wcs-custom-dropdown li").off(self.eventType).on(self.eventType, {"self": self, "fromElem": "size"}, self.changeSizeDropDownHandler);
		$(".so-quickview-email-me").off(self.eventType).on(self.eventType, {"self": self}, self.openEmailPopUp);
		$("#D_QuickView_PolarBtn .dd-options li").off("click").on("click", {"self": self, "fromElem": "type"}, self.changeSizeDropDownHandler);
	},

	render: function(){
		var self = this,
            firstProduct="",
            label;



        $.each(this.product[0].carousel,function(index,value){
        	if(value.selected)
        		firstProduct=value.details.value;
    	});
        this.productSKU = firstProduct;
		if(this.product[0].carousel.length>1){
			this.preLoadimages(this.product[0].carousel);
			this.container.find('.slider-container').attr('style','display:block');
			this.sliderRender(this.product[0]);
		}else{
			this.container.find('.slider-container').attr('style','display:none');
		}

        if(this.product[0].hasOwnProperty("label"))
        	 label = this.product[0].label;
        else
        	 label = "";

		this.selectedProductData = this.product[1][firstProduct];
		this.currencySymbol = this.product[0].currencySymbol;
		if(window.isROX == "true" || ($("#isRoxEnabled").length>0 && $("#isRoxEnabled").val() === "true")){
           /****override addTobagFlag of selectedData with the frame addToBagFlag***/
		   this.selectedProductData.addToBagFlag = this.product[1][this.selectedProductData.frameCatentryId].addToBagFlag;
		   self.updateROXPrices();
		}

		this.layoutRender(this.product[1][firstProduct], label,"onReady");

		window.display_center_1(this.container);
		window.show_full_fadeout_1();
		this.container.show().removeClass("wcs-hidden").removeClass("wcs-hide");
		load_scroller();
	    expand_dropbox();
	    this.bindEvent(self);
	    this.checkifAddedToWishList(this.product[1][firstProduct].catentryId);
	    window.initNotification();

	},
	sliderRender: function(product) {
		var self = this;
		this.sliderContainer.html("");
		this.sliderContainer.html(this.quickViewTemplate({p: 'bottom_carousel', templateData: product}));

		if($("#productCatType").val() != "accessories"){

			var activeSliderIndex = 0;
			var sIndx = $("#D_QuickView_Prod_ColorsThumbs .wcs-selected").index();
    	    activeSliderIndex = sIndx/4;
    	    activeSliderIndex = parseInt(activeSliderIndex);
    	   window.qvCarousel = undefined;


		   setTimeout(function(){


			   if($("#D_QuickView .wcs-carousel li").length > 4){
				   window.qvCarousel = $("#D_QuickView .wcs-carousel").bxSlider({
		               infiniteLoop: false,
		               hideControlOnEnd: true,
		               slideWidth: 110,
		               startSlide: activeSliderIndex,
		               slideMargin: 10,
		               pager: false,
		               minSlides: 1,
		               maxSlides: 4,
		               moveSlides: 4,
		               preloadImages: 'all',
		               onSliderLoad: function() {
		   					var framelabelYPos = $(".wcs-carousel li:first").find(".wcs-quickView-product-list-frame").position().top;
		   					$(".frameLensLabelCntr").css({"top": framelabelYPos+"px"});
		   					self.container.find(".slider-container").css({"visibility": "visible"});
		   					self.container.find(".bx-prev").attr('id','D_QuickView_Prod_ColorsPrev');
	    					self.container.find(".bx-next").attr('id','D_QuickView_Prod_ColorsNext');

		   					if(product.length <= 4){
		    					self.container.find(".bx-prev").hide();
		    					self.container.find(".bx-next").hide();
		    				}else{
		    					self.container.find(".bx-prev").show();
		    					self.container.find(".bx-next").show();
		    				}
		               }
		           });
			   }else {
				   window.qvCarousel = self.container.find(".wcs-carousel").bxSlider({
		               infiniteLoop: false,
		               hideControlOnEnd: true,
		               slideWidth: 110,
		               startSlide: activeSliderIndex,
		               slideMargin: 10,
		               pager: false,
		               controls: false,
		               minSlides: 1,
		               maxSlides: 4,
		               moveSlides: 4,
		               preloadImages: 'all',
		               onSliderLoad: function() {
		   					var framelabelYPos = $(".wcs-carousel li:first").find(".wcs-quickView-product-list-frame").position().top;
		   					$(".frameLensLabelCntr").css({"top": framelabelYPos+"px"});
		   					self.container.find(".slider-container").css({"visibility": "visible"});
		   					self.container.find(".bx-prev").attr('id','D_QuickView_Prod_ColorsPrev');
	    					self.container.find(".bx-next").attr('id','D_QuickView_Prod_ColorsNext');

		   					if(product.length <= 4){
		    					self.container.find(".bx-prev").hide();
		    					self.container.find(".bx-next").hide();
		    				}else{
		    					self.container.find(".bx-prev").show();
		    					self.container.find(".bx-next").show();
		    				}
		               }
		           });
			   }

		   }, 500);


        }
	},

	layoutRender: function(product, availblMsg,eventType) {

		var self = this;

		this.layoutContainer.html(this.quickViewTemplate({p: 'quickview_desc', products: product }));

		expand_dropbox();
		$(".wcs-size-dropdown li").off(this.eventType).on(this.eventType, this.changeSizeDropDownHandler);
		window.initNotification();

		$('#D_QuickView_PolarSelection').ddslick({
			width: 128,
			imagePosition: "left",
			background : '#fff',
			onSelected : function(data){
				self.adjustOptionsHeight($("#D_QuickView_PolarSelection"));
				$(".dd-option").parent().show();
				$(".dd-option-selected").parent().hide();

			}
		});

		var D_QuickView_PolarSelectionSelect = $("#D_QuickView_PolarSelection");
		var len_polarNonpolar = D_QuickView_PolarSelectionSelect.find(".dd-options li").length;

		if(len_polarNonpolar == 1){
			$(".dd-select, .dd-selected, .dd-selected").off("click");
			D_QuickView_PolarSelectionSelect.find(".dd-pointer").hide();
		}else {
			D_QuickView_PolarSelectionSelect.find(".dd-pointer").show();
		}

		//remove shadow and add it only on open
		$('.dd-select').on('click',function(){
			if($(this).find('.dd-pointer').is(':visible')){
				$(this).toggleClass('open-shadow');
			}
		});

		var sizeSelect = $("ul.wcs-custom-dropdown");
		var sizeOptions = sizeSelect.find("li").length;

		if(sizeOptions == 1){
			$("#wcs-size-display").addClass("no-event");
			$(".wcs-custom-dropdown-select").addClass("no-event");
			$(".wcs-custom-dropdown-select .wcs-dropdown-icon ").hide();
		}else {
			$(".wcs-custom-dropdown-select .wcs-dropdown-icon ").show();
		}
		self.callAnalytics(product,eventType);
	},

	adjustOptionsHeight: function(obj) {
		var lOHeight = '14px';

		obj.find('.dd-option').each(function () {
            var $this = $(this);
            var descriptionOption = $this.find('.dd-option-description');
            var imgOption = obj.find('.dd-option-image');
            if (descriptionOption.length <= 0 && imgOption.length > 0) {
                $this.find('.dd-option-text').css('line-height', lOHeight);
            }
        });

		$('.dd-selected-text').css('line-height', lOHeight);
    },

     addToBagHandler: function(e){
		e.preventDefault();
		var data = e.data;
		if(data.self.container.find('#wcs-size-selectedSize').length>0 && -1 != data.self.container.find('#wcs-size-selectedSize').attr('class').indexOf('dummy-select')){
			data.self.container.find('.qty-stock-msg').removeClass('wcs-hide');
			return;
		}
		/*If quicview add clear session storage */
		 // sessionStorage.removeItem("rayban." + $("#storeId").val() + "." + $("#langId").val() + ".sidebar_refreshLS");
		 // sessionStorage.removeItem("rayban." + $("#storeId").val() + "." + $("#langId").val() + ".headerprofile_refreshLS");

		  data.self.container.find(".wcs-addedtobag").show();
		  $(".quickview-prod-addtocart").hide();
		  data.self.container.find(" .wcs-addedtobag").text($("#addingText").val()+"..");
		 // setTimeout(function(){
		   // $(e.target).removeClass("wcs-addedtobag");
		    //window.hide_full_fadeout(data.self.containerId);
		   // data.self.container.hide();
		    if(!data.self.isiPad)
		    	product_ID_fn(e);
		//  },2000);
	},

	close: function(e){
		e.preventDefault();
		/*If quicview add clear session storage */
		var data = e.data;
		window.hide_full_fadeout(data.self.containerId);
		data.self.container.hide();
	},

	productListHandler: function(e){
		e.preventDefault();
		var data = e.data.self;
		data.container.find('.qty-stock-msg').addClass('wcs-hide');
        data.productSku = $(e.target).closest("li").data("product_sku");
		var selectedProduct = data.product[1][data.productSku];
		data.selectedProductData = selectedProduct;
		if(window.isROX == "true" || ($("#isRoxEnabled").length>0 && $("#isRoxEnabled").val() === "true")){
			/****override addTobagFlag of selectedData with the frame addToBagFlag***/
			data.selectedProductData.addToBagFlag = data.product[1][data.selectedProductData.frameCatentryId].addToBagFlag;
			data.updateROXPrices();
	    }
        data.container.find(".slider-container .wcs-carousel li").removeClass("wcs-selected");
		$(e.target).closest("li").addClass("wcs-selected");
		data.layoutRender(selectedProduct,"","");
		data.bindEvent(data);
		data.checkifAddedToWishList(selectedProduct.catentryId);
	},

	checkifAddedToWishList : function(defaultCatId){
		var self = this;
    	var wishListCatentryIds = $("#wishListCatentryIds").val();
    	if(undefined !== wishListCatentryIds){
	 	wishListCatentryIds = wishListCatentryIds.replace("[","").replace("]","").split(",");
    	}
    	$.each(wishListCatentryIds, function(itr,catEntryId){
	    	if($.trim(defaultCatId) == $.trim(catEntryId))
		 	{
	    		if(self.container.find(".wcs-fav-container").find("span").hasClass("wcs-quickbuy-favourite")) {
                    self.container.find(".wcs-fav-container").find("span").removeClass("wcs-quickbuy-favourite").addClass("wcs-quickbuy-tickMark");
                    self.container.find(".wcs-fav-container").find("a").addClass("wcs-favourite-added").text(self.container.find(".wcs-fav-container").find("a").data("save-label"));
                 }
	         return;
	        }
		});
    },

	changeSizeDropDownHandler: function(e){
		e.preventDefault();
		var self = this;
		var data = e.data.self;
		var el = e.currentTarget;
		if(e.data.fromElem == "size") {
			this.productSKU = $(el).data("catid");
		}
		else if(e.data.fromElem == "type"){
			this.productSKU = $(el).find(".dd-option-value").val();
		}
		var selectedProduct = [];
		var eventType = "";
		if(window.isROX == "true" || ($("#isRoxEnabled").length>0 && $("#isRoxEnabled").val() === "true")){
			if(e.data.fromElem == "size") {
				$("#frameCatentryId").val(this.productSKU);
				/**Change the frame id and lens data remains same. Merge the frame and lens data before rerender**/
	            data.mergeLensframeData();
	            selectedProduct = data.selectedProductData;
	            selectedProduct.frameCatentryId =  this.productSKU;
	            eventType = "onFrameChange";
            }
            else{
            	selectedProduct = data.product[1][this.productSKU];
			    data.selectedProductData = selectedProduct;
			    data.mergeLensframeData();
            }
		}
        else{
			selectedProduct = data.product[1][this.productSKU];
			data.selectedProductData = selectedProduct;
		}
		data.container.find('.qty-stock-msg').addClass('wcs-hide');
		if("true" == $(el).find(".dd-option-isDummy").val() || true === $(el).find(".dd-option-isDummy").val()){
			data.sizeDropdownContainer 	= $("#wcs-size-display");
			data.sizeDropdownContainer.html(data.quickViewTemplate({p: 'dummy_select_qv', products: selectedProduct }));
			expand_dropbox();
			data.bindEvent(data);
			return;
		}
		//$(".slider-container .wcs-carousel li").removeClass("wcs-selected");

		data.layoutRender(selectedProduct,"",eventType);
		data.bindEvent(data);
		data.checkifAddedToWishList(selectedProduct.catentryId);
	},
	openEmailPopUp: function(e){
		var data = e.data;
		var el = e.currentTarget;

		var productSKU = $(el).data("catid");
		var selectedProduct = data.self.product[1][productSKU];

    	storeID = $("#storeId").val();
		catalogID = $("#catalogId").val();
		langId = $("#langId").val();
		emailSRC = "EmailTest";
		productId = selectedProduct.catentryId;
		metaTitle = $.trim(selectedProduct.modelName);
		sku = selectedProduct.displaySKU;
		partNumber = selectedProduct.partNumber;
		altText = selectedProduct.altText;
		title = $.trim(selectedProduct.modelName);
		categoryTypeForEmail = selectedProduct.productType;
		prodCatType = selectedProduct.productType;
		name = $.trim(selectedProduct.modelName);
		if (selectedProduct.onSaleVal == "TRUE") {
			price = $.trim(selectedProduct.offerPrice);
			clearancePrice = $.trim(selectedProduct.listPrice);
		} else {
			price = $.trim(selectedProduct.offerPrice);
			clearancePrice = "";
		}
		data = {"storeId": storeID, "catalogId": catalogID, "catEntryId": productId, "langId": langId, "emailSRC": emailSRC,"metaTitle": metaTitle, "sku": sku, "productId": productId, "partNumber": partNumber, "altText": altText, "title": title, "categoryTypeForEmail": categoryTypeForEmail,"prodCatType": prodCatType, "price": price, "name": name,"clearancePrice":clearancePrice};
		sendAjaxRequest('PreOrderRemindMeEmailView', appendNotificationData, data);
    },

    preLoadimages: function(carouselData){

    	var $preloadImgContainer = null;

    	if($("#preloadQVImgContainer").length === 0){
    		$preloadImgContainer = $("<div>").attr("id", "preloadQVImgContainer").hide();
    	}else{
    		$preloadImgContainer = $("#preloadQVImgContainer").hide();
    	}
    	$.each(carouselData, function(index, carouselObj){
    		var $img = $("<img>").attr("src", carouselObj.details.imageUrl+".png?impolicy=RB_Product_small");
    		$img.attr("width", "1");
    		$img.attr("height", "1");
    		$preloadImgContainer.append($img);
    	});

    	this.container.append($preloadImgContainer);
    },

    callAnalytics : function(product,eventType){
    	var self = this;
    	window.tealium_data2track = window.tealium_data2track || [];
    	var selectedData = {};
    	var data ={};
    	var selectedPartNumber = product.partNumber;
    	var selectedPrice="";
    	if(product.unFormattedPrice !== undefined){
    		selectedPrice = product.unFormattedPrice;
    	}
    	data.Category=product.productCategory;
    	data.Units=1;
    	data.Price=selectedPrice;
    	//logic to derive status of item
    	var status="";
    	if("Y" == product.addToBagFlag){
    		status="Available";
    	}else{
    		if("ACTIVE" == product.lifecycleVal ||
    				undefined === product.lifecycleVal){
    			if(0 === product.buyableqty){
					if (product.emailLinkFlag === "Y") {
						status = "out-of-stock-emailme";
					} else {
						status = "out-of-stock";
					}
    			}
    			if(0 < product.buyableqty){
    				status="NotSellable";
    			}
    		}else{
    				status="NotSellable";
    		}
    	}
    	data.Status=status;
    	data.DataSource=product;
    	// pricestrike strike through
		var x = data.DataSource;
		if (x.hasOwnProperty('listPrice') && x.onSaleVal == "FALSE") {
			x.promotionalPrice = x.offerPrice;
			data.DataSource = x;
		}
		// end of pricestrike through
    	var eventId ="";
    	selectedData[""+selectedPartNumber]=data;
    	window.tealium_data2track.push({
			id : "WCS-X-QuickViewOverlay-QuickviewProds-Init",
			Products : selectedData
        });
        window.tealium_data2track.push({
        	id : "WCS-D-QuickViewOverlay-Loading-Ready"
        });
    }

});
